import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Spin, message, Modal } from "antd";
import { ArrowLeftOutlined, HomeOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import RegistrationItem from "./RegistrationItem";
import { trackRegisterClick, trackInfoClick } from "services/statsService";
import Layout from "pages/HomePage/Layout";
import "./CategoryPage.css";

const CategoryPage = () => {
  const { categoryId } = useParams();
  const history = useHistory();
  const [isBusy, setIsBusy] = useState(false);
  const [category, setCategory] = useState(null);
  const [registrations, setRegistrations] = useState([]);
  const [pdfModalVisible, setPdfModalVisible] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");

  // Get appInfo from Redux (already loaded by HomePage)
  const appInfo = useSelector(state => state.appDataStore?.appInfo);

  useEffect(() => {
    if (appInfo) {
      loadCategoryData();
    }
  }, [categoryId, appInfo]);

  const loadCategoryData = () => {
    // Find the category from appInfo (compare as strings for consistency)
    const foundCategory = appInfo?.homepage_categories?.find(
      cat => String(cat.id) === String(categoryId)
    );

    if (!foundCategory) {
      console.error("Category not found. Available categories:", appInfo?.homepage_categories?.map(c => c.id));
      message.error("Category not found");
      history.push("/");
      return;
    }

    setCategory(foundCategory);

    // Get registrations for this category (use string key), excluding hidden (status=2)
    const categoryRegistrations = (appInfo?.registrations_by_category?.[String(categoryId)] || [])
      .filter(reg => reg.status !== "2" && reg.status !== 2);
    setRegistrations(categoryRegistrations);
  };

  const handleRegister = (registrationId) => {
    trackRegisterClick(registrationId);
    localStorage.setItem("camper_step", "0");
    history.push(`/register?id=${registrationId}`);
  };

  const handleShowInfo = (infoUrl, registrationId) => {
    trackInfoClick(registrationId, categoryId);
    setPdfUrl(infoUrl);
    setPdfModalVisible(true);
  };

  const handleGoHome = () => {
    history.push("/");
  };

  if (!category) {
    return (
      <div style={{ textAlign: "center", padding: "100px 20px" }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <Layout appInfo={appInfo}>
    <div className="category-page">
      <div className="category-header">
        <div className="header-actions">
          <button className="back-btn" onClick={() => history.goBack()} title="Go Back">
            <ArrowLeftOutlined />
          </button>
          <button className="home-btn" onClick={handleGoHome} title="Return to Home">
            <HomeOutlined />
          </button>
        </div>
        <h1 className="category-title">{category.title}</h1>
        <p className="category-description">{category.description}</p>
      </div>

      <div className="registrations-container">
        {registrations.length > 0 ? (
          <div className="registrations-list">
            {registrations.map((registration) => (
              <RegistrationItem
                key={registration.id}
                registration={registration}
                onRegister={handleRegister}
                onShowInfo={handleShowInfo}
              />
            ))}
          </div>
        ) : (
          <div className="no-registrations">
            <p>There aren't any registrations available for this category at this time.</p>
          </div>
        )}
      </div>

      {/* PDF Info Modal */}
      <Modal
        title="Registration Information"
        open={pdfModalVisible}
        onCancel={() => setPdfModalVisible(false)}
        footer={null}
        width="90%"
        style={{ top: 20 }}
        destroyOnClose
      >
        <iframe
          src={pdfUrl}
          style={{
            width: "100%",
            height: "80vh",
            border: "none"
          }}
          title="Registration Information"
        />
      </Modal>
    </div>
    </Layout>
  );
};

export default CategoryPage;
